module.exports = __webpack_public_path__ + "static/media/HELI-CPD30-2.49b3495a.jpg";